import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=3e209df8&scoped=true"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=3e209df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e209df8",
  null
  
)

export default component.exports